import { render, staticRenderFns } from "./StatDiamond.vue?vue&type=template&id=4644c272&scoped=true&"
import script from "./StatDiamond.vue?vue&type=script&lang=js&"
export * from "./StatDiamond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4644c272",
  null
  
)

export default component.exports